// extracted by mini-css-extract-plugin
export default {"image":"J0bN1PXOyGFNkiHzNL_v","badge":"BUEXjyBZU5WlGqY4zE5P"};